import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import KlausurEdit from "../../newForms2/klausuren/KlausurEdit";
import KlausurNew from "../../newForms2/klausuren/KlausurNew";
import KlausurDetails from "./KlausurDetails";
import KlausurenButtons from "./KlausurenButtons";
import OpenInput from "./OpenInput";
import {getBackendUrl, getFrontendUrl} from "../../helpers/urls";

const KlausurenMain = () => {
  const [view, setView] = useState("buttons");
  const currentKlausur = useSelector(st => st.currentKlausur);
  const companies = useSelector(st => st.companies);
  const users = useSelector(st => st.users);
  const textbausteine = useSelector(st => st.textbausteine);
  const currentUser = useSelector(st => st.currentUser);

  useEffect(() => {
    if (!!currentKlausur.id) {
      setView("klausur");
    } else {
      setView("buttons");
    }
  }, [currentKlausur, setView]);

  // console.log({companies, users, textbausteine, currentUser, frontendUrl: getFrontendUrl(), backendUrl: getBackendUrl()});
  return (
    <div>
      <div>
        {view === "buttons" && <KlausurenButtons setView={setView} />}
        {view === "formNew" && <KlausurNew setView={setView} />}
        {view === "formEdit" && <KlausurEdit setView={setView} />}
        {view === "klausur" && <KlausurDetails setView={setView} />}
        {view === "openInput" && <OpenInput setView={setView} />}
      </div>
    </div>
  );
};
export default KlausurenMain;
